/**
 * Created by hp on 2017/6/6.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Preload} from '../../components'
import Timestamp from '../Timestamp'
import axios from 'axios'
import {
    VoiceMessage,
    TextMessage,
    MusicMessage,
    ImageMessage,
    VideoMessage,
    CardMessage,
    CheckInMessage,
    RedpackMessage,
    RewardMessage,
    FileMessage,
    ShareCardMessage
} from '../messages'
import ScrollButton from '../ScrollButton'
import toTextLoadingImg from '../../images/classroom/to-text-loading.png'
import toTextSuccessImg from '../../images/classroom/to-text-success.png'
import toTextWarningImg from '../../images/classroom/to-text-warning.png'
import cn from 'classnames'
import config from '../../config'

import default_avatar from '../../images/default.png'
import '../../styles/MessageList.css'
import ClassroomReportFileDialog from './ClassroomReportFileDialog'
import {Toast} from 'react-weui'
import { setEvent } from '../../utils'

class TimeSpan extends React.Component {
    shouldComponentUpdate() {
        return false
    }

    render() {
        const {timestamp} = this.props

        return (
            <div className="timespan">
                <Timestamp timestamp={timestamp}/>
            </div>
        )
    }
}

class MessageItem extends React.PureComponent {
    state = {
        small_avatar_url: default_avatar
    }

    componentWillMount() {
        const {lecturer} = this.props
        if (lecturer.account) {
            this.setState({small_avatar_url: lecturer.account.small_avatar_url})
        }
    }

    componentDidMount() {
        const {lecturer, message} = this.props
        if (!lecturer.account) {
            this.context.classroomPage.lazyLoads.push({
                el: document.getElementById('message_' + message.id),
                onVisible: this.onVisible.bind(this)
            })
        }
    }

    onVisible() {
        const {message} = this.props
        this.setState({small_avatar_url: message.account.small_avatar_url})
    }

    renderContent() {
        const {message, dispatch, lecture, messageList} = this.props

        switch (message.type) {
            case 'text':
                return <TextMessage message={message} dispatch={dispatch}/>
            case 'voice':
                return <VoiceMessage message={message} currentAudioItem={messageList.currentAudioItem}
                                     dispatch={dispatch}/>
            case 'image':
                return <ImageMessage message={message}/>
            case 'video':
            case 'iframe':
                return <VideoMessage message={message}/>
            case 'music':
                return <MusicMessage message={message}/>
            case 'lecture_card':
            case 'channel_card':
            case 'liveroom_card':
                return <CardMessage type={message.type} message={message}/>
            case 'check_in':
                return <CheckInMessage message={message} dispatch={dispatch} lecture={lecture}/>
            case 'redpack':
                return <RedpackMessage message={message} dispatch={dispatch} lecture={lecture}/>
            case 'file':
            case 'doc':
                return <FileMessage message={message} lecture={lecture}/>
            case 'sharecard':
                return <ShareCardMessage message={message} dispatch={dispatch}/>
            default:
                return message.type
        }
    }

    renderStatus() {
        const {message} = this.props
        if (message.status === 'send' || message.status === 'queued')
            return <span className="">等待发送</span>

        if (message.status === 'saving')
            return <span className="">
                <i className="iconfont icon-jiazai"></i>
                保存中
            </span>

        if (message.status === 'sending')
            return <span className="">
                <i className="iconfont icon-jiazai"></i>
                发送中
            </span>

        if (message.status === 'failed')
            return <span className="danger">
                <i className="iconfont icon-cuowu"></i>
                发送失败， 请点击...重试
            </span>

        if (this.props.role.is_lecturer) {
            if (message.type === 'voice' && message.meta.wave_points) {
                let p5 = message.meta.wave_points.sort((a, b) => (b - a))[5]
                if (p5 < 100) {
                    return <span className="danger">
                        已发送, 未检测到声音, 请检查输入设备或尝试刷新
                    </span>
                } else if (p5 < 500) {
                    return <span>
                        已发送, 但是检测到声音小, 请尝试靠近麦克风
                    </span>
                }
            }
        }
        if (message.status === 'success')
            return <span className="">
                <i className="iconfont icon-duigou"></i>
                发送成功
            </span>
    }

    getToTextStatusImg(status) {
        switch (status) {
            case 'pending':
                return toTextLoadingImg
            case 'success':
                return toTextSuccessImg
            case 'fail':
                return toTextWarningImg
            default:
                return toTextSuccessImg
        }
    }

    render() {
        const {message, lecturer, canOperate, handleOperate, handleReward, can_reward, messageList} = this.props
        const isReply = message.meta && message.meta.reply
        const toText = messageList.toTexts.find(item => item.id === message.id)

        if (['liveroom_vip_card', 'group_card'].indexOf(message.type) > -1) {
            return null
        }

        // 支付宝过滤课堂页邀请卡消息
        if (window.platform === 'alipay' && message.type === 'sharecard') {
            return null
        }

        switch (message.type) {
            case 'reward':
                return (<div className="message-item" id={'message_' + message.id}>
                    <RewardMessage message={message} handleReward={handleReward}/>
                </div>)
            default:
                return (<div className="message-item" id={'message_' + message.id}>
                    <div className="left-side" onClick={e => handleReward(message.account)}>
                        <div className="avatar">
                            <img className="circle" alt=""
                                 src={this.state.small_avatar_url}/>
                        </div>
                        {can_reward &&
                        <div className="reward">
                            <span className="reward-icon">赏</span>
                        </div>
                        }
                    </div>
                    <div className="right-side">
                        <div className="name">
                            <span className="nickname">{message.account.nickname}</span>
                            <span className="title">{lecturer.title}</span>
                        </div>
                        <div className={'content ' + (isReply ? 'reply' : '')}>
                            {isReply &&
                            <div>
                                <div
                                    className="reply-text ">
                                    <span className="title">引用</span>
                                    {message.meta.reply}
                                </div>
                            </div>
                            }
                            {this.renderContent()}
                            {
                                canOperate &&
                                <span className="operate" onClick={e => {
                                    handleOperate(message)
                                }}>
							        <i className="iconfont icon-gengduo1" aria-hidden="true"></i>
						        </span>
                            }
                        </div>
                        {
                            toText && (
                                <div className="voice-to-text">
                                    {
                                        toText.status === 'success' && <div className="text">{toText.text}</div>
                                    }
                                    <div className={cn('status', toText.status || '')}>
                                        <div className='icon'>
                                            <img src={this.getToTextStatusImg(toText.status)} alt=""/>
                                        </div>
                                        <div className="msg">
                                            {toText.status === 'pending' && '正在转换'}
                                            {toText.status === 'success' && '转换完成'}
                                            {toText.status === 'fail' && '转换超时，请重试'}
                                        </div>
                                    </div>
                                    {
                                        (toText.status === 'success' && toText.via) && (
                                            <div className="via">{toText.via}</div>
                                        )
                                    }
                                </div>
                            )
                        }
                        <div className="status">
                            {this.renderStatus()}
                        </div>
                    </div>
                </div>)
        }
    }
}


MessageItem.contextTypes = {
    classroomPage: React.PropTypes.object
}


class ClassroomMessageList extends Component {
    constructor() {
        super()
        this.currentReads = []
        this.audioItems = {}
        this.keepPosition = null
        this.handleReward = this.handleReward.bind(this)
        this.handleOperate = this.handleOperate.bind(this)
        this.dumpMessages = this.dumpMessages.bind(this)
        this.state = {reportFileContent: null, reportSuccessToast: null}
    }

    getChildContext() {
        return {messageList: this}
    }

    dumpMessages() {
        const {lecture, messageList, role} = this.props
        const {messages} = messageList
        if (role.is_lecturer && messageList.initialized) {
            let to_dump = messages.filter(v => v.status && ['failed', 'sending', 'saving', 'queued', 'send'].indexOf(v.status) > -1 && v.from !== 'pc')

            to_dump = to_dump.map(v => ({...v, status: 'failed'}))
            to_dump = JSON.stringify(to_dump)
            if (this.last_dump === to_dump) {
                return
            }
            this.last_dump = to_dump
            console.log('dump messages', to_dump)
            if (to_dump === '[]') {
                localStorage.removeItem('lecture-unsend-' + lecture.id)
            } else {
                localStorage.setItem('lecture-unsend-' + lecture.id, to_dump)
            }
        }
    }

    componentDidMount() {
        const data = localStorage.getItem('lectureReads/' + this.props.lecture.id)
        if (data) {
            this.currentReads = JSON.parse(data)
        }

        axios.get('/api/classroom/' + this.props.lecture.id + '/message/list', {
            params: {
                is_reverse: 1,
                limit: 2000,
                _: Math.random()
            }
        }).then((response) => {
            if (response.data.code === 0) {
                let {messages = []} = response.data.data
                let dump = localStorage.getItem('lecture-unsend-' + this.props.lecture.id)

                if (dump) {
                    dump = JSON.parse(dump)
                    console.log('load', dump)
                    dump = dump.filter(v =>
                        messages.findIndex(vv => vv.timestamp === v.timestamp) === -1
                    )
                    messages = messages.concat(dump)
                }

                this.props.dispatch({
                    type: 'ML_LOAD',
                    payload: {
                        messages: messages.sort((a, b) => (a.timestamp - b.timestamp))
                    }
                })
            }
        })

        this.context.classroomPage.lazyLoads.push({
            onScroll: this.onScroll.bind(this)
        })
    }

    isMessageRead(id) {
        return this.currentReads.indexOf(id) !== -1
    }

    getLecturer(message) {
        const {lecturers} = this.props
        for (let k in lecturers) {
            if (lecturers[k].account.id === message.account.id) {
                return lecturers[k]
            }
        }
        return {}
    }

    onImageClick(item) {
        const {messages} = this.props.messageList
        const urls = messages.filter(m => m.type === 'image').map(m => (m.content && m.content.replace(/[\/-]picmsg420/, '')) || m.local_id)
        if (window.wxReady) {
            window.wx.previewImage({
                current: item.getSourceUrl(), // 当前显示图片的http链接
                urls: urls // 需要预览的图片http链接列表
            })
        } else {
            this.props.dispatch({
                type: 'SHOW_IMAGE_PREVIEWER',
                payload: {
                    imageUrl: item.getSourceUrl()
                }
            })
        }
    }

    onAudioStart(item) {
        // 如果能做到播放状态在messageList.messages里又不影响性能就最好，荣哥之前的方法
        const {message} = item.props
        const {messageList, lecture} = this.props
        let firstRead = false

        // 标记为已读
        if (typeof message.id === 'number' && !this.isMessageRead(message.id)) {
            this.currentReads.push(message.id)
            localStorage.setItem('lectureReads/' + lecture.id, JSON.stringify(this.currentReads))
            firstRead = true
        }
        // 保存当前位置
        localStorage.setItem('lastReadMessageId/' + lecture.id, message.id)
        localStorage.setItem('autoPlay/' + lecture.id, '1')
        // 停掉上一条正在播放的语音
        if (messageList.currentAudioItem) {
            messageList.currentAudioItem.stop()
        }
        // 通知播放器
        let dataUrl = null
        if (message.type === 'voice') {
            message.content = message.content || ''
            if (message.content.indexOf('http') === 0) {
                dataUrl = message.content
            } else if (message.content.indexOf('data:') === 0) {
                dataUrl = message.content
            } else {
                dataUrl = message.local_id
            }
        } else if (message.type === 'music') {
            dataUrl = message.meta.play_url || message.meta.audio_url
        }
        // 统计播放语音的条数--量化评价
        if (this.props.evaluationAudioCount < 10) {
            this.props.dispatch({
                type: 'WK_SET_AUDIO_LISTENCOUNT'
            })
        }
        // 获取最后一条语音的id--量化评价
        let audio_list = messageList.messages.filter(mess => mess.type === 'voice')
        if (audio_list.length > 1) {
            let last_audio_id = audio_list[audio_list.length - 1].id
            if (last_audio_id === message.id) {
                this.props.dispatch({
                    type: 'WK_SET_IS_AUDIO_LAST'
                })
            }
        }

        this.props.dispatch({
            type: 'AUDIO_LOAD',
            payload: {
                dataUrl: dataUrl,
                messageItem: item,
                message: message
            }
        })
        this.props.dispatch({
            type: 'STATS_LOG',
            payload: {
                action: 'listen_audio',
                lecture_id: lecture.id,
                message_id: message.id,
                ts: new Date().getTime(),
                account_id: this.props.role.account_id
            }
        })

        // 滚动到这条语音
        if (!messageList.currentAudioItem || messageList.currentAudioItem.isInViewport()) {
            if (!item.isInViewport()) {
                this.scrollToMessage(message.id)
            }
        }

        // 结束课程，加载弹幕，如果要关闭，注释这里即可。
        const {showDiscussListArea} = this.props
        if (firstRead && lecture.status === 'closed' && showDiscussListArea) {
            const {classroom} = this.context.classroomPage.props
            if (classroom.stats.discuss_count > 0) {
                axios.get(`/api/classroom/${lecture.id}/message/${message.id}/related_discuss`).then((response) => {
                    if (response.data.code === 0) {
                        this.props.dispatch({
                            type: 'DELAY_POPUP_LOAD',
                            payload: {
                                popups: response.data.data.discusses,
                                playTime: Date.now(),
                                pastTime: message.timestamp
                            }
                        })
                    }
                })
            }
        }
    }

    scrollToMessage(id, immediate) {
        const el = document.getElementById('message_' + id)
        if (el) {
            this.context.classroomPage.scrollTo(el.offsetTop, immediate)
        }
    }

    onScroll() {
        const {messageList, audioPlayer, showScrollButton} = this.props
        if (messageList.currentAudioItem) {
            if (audioPlayer.audioState === 'playing') {
                if (!messageList.currentAudioItem.isInViewport()) {
                    if (!showScrollButton) {
                        this.props.dispatch({
                            type: 'CLASSROOM_SHOW_SCROLL_BUTTON'
                        })
                    }
                    return
                }
            }
        }
        if (showScrollButton) {
            this.props.dispatch({
                type: 'CLASSROOM_HIDE_SCROLL_BUTTON'
            })
        }
    }

    onAudioStop(item) {
        // 清除当前位置
        localStorage.removeItem('autoPlay/' + this.props.lecture.id)

        this.props.dispatch({
            type: 'AUDIO_STOP'
        })
    }

    onAudioSeek(item, seekTime) {
        this.props.dispatch({
            type: 'AUDIO_SEEK',
            payload: {
                time: seekTime
            }
        })
    }

    handleResendMessage(operatingMessage) {
        this.context.page.hideMenu()
        const id = operatingMessage.id
        if (operatingMessage.type === 'voice' && operatingMessage.local_id && !operatingMessage.server_id) {
            this.props.dispatch({
                type: 'ML_TOGGLE_MESSAGE',
                payload: {
                    id: id,
                    status: 'queued'
                }
            })
            return
        }
        this.props.dispatch({
            type: 'ML_TOGGLE_MESSAGE',
            payload: {
                id: id,
                status: 'send'
            }
        })
    }

    handleDeleteMessageConfirm(message) {
        this.context.page.hideMenu()
        this.context.page.showConfirm(
            '',
            '确定撤回吗？',
            () => this.handleDeleteMessage(message)
        )
    }

    handleDeleteMessage(operatingMessage) {
        this.context.page.hideMenu()
        const {lecture} = this.props
        const id = operatingMessage.id

        if (id.toString().indexOf('.') > -1) {
            this.props.dispatch({
                type: 'ML_DELETE_MESSAGE',
                payload: {
                    id: id
                }
            })
        } else {
            axios.post(`/api/classroom/${lecture.id}/message/${id}/delete`).then((response) => {
                if (response.data.code === 0) {
                    this.props.dispatch({
                        type: 'ML_DELETE_MESSAGE',
                        payload: {
                            id: id
                        }
                    })
                }
            })
        }
    }

    reportFileSuccess() {
        this.setState({reportSuccessToast: true})
        setTimeout(() => this.setState({reportSuccessToast: false}), 3000)
    }

    reportFile(category, message) {
        const lectureId = this.props.lecture.id
        const file_url = message.meta && (message.meta.doc_url || message.meta.file_url)
        const file_name = message.meta && (message.meta.doc_name || message.meta.file_name)
        if (category === 'others') {
            this.setState({
                reportFileContent: {
                    onBack: () => this.setState({reportFileContent: null}),
                    onReport: (reason) => {
                        if (reason) {
                            const form = new FormData()
                            form.append('category', category)
                            form.append('reason', reason)
                            form.append('file_name', file_name)
                            form.append('file_url', file_url)
                            axios.post(`/api/classroom/${lectureId}/complain`, form, {headers: {'content-type': 'multipart/form-data'}})
                            this.setState({reportFileContent: null})
                            this.reportFileSuccess()
                        } else {
                            alert('举报内容不能为空')
                        }
                    }
                }
            })
            this.context.page.hideMenu()
        } else {
            const form = new FormData()
            form.append('category', category)
            form.append('reason', '')
            form.append('file_name', file_name)
            form.append('file_url', file_url)
            axios.post(`/api/classroom/${lectureId}/complain`, form, {headers: {'content-type': 'multipart/form-data'}})
            this.context.page.hideMenu()
            this.reportFileSuccess()
        }
    }

    handleVoiceToText(message) {
        const DEBUG = config.DEBUG
        const toTextApi = DEBUG ? 'http://118.89.45.243:9301/open_api/recognize' : '/open_api/recognize'
        this.context.page.hideMenu()
        if (!/^http/.test(message.content)) {
            return window._wk_toast.show('请刷新页面后转换', '', 2000)
        }
        if (message.status !== 'received' && message.status !== 'success' && message.status) {
            return window._wk_toast.show('请在发送成功后转换', '', 2000)
        }
        const toText = this.props.messageList.toTexts.find(item => item.id === message.id) || {}
        if (toText.status === 'success') {
            return window._wk_toast.show('转换已完成', 'https://static-1253442168.image.myqcloud.com/picture/5442190_3cfb79fb24a8e01825b80375ae553ab0.jpg', 2000)
        }
        if (toText.status === 'pending') {
            return window._wk_toast.show('正在转换...', '', 2000)
        }
        if (toText.status === 'fail') {
            this.props.dispatch({
                type: 'ML_SET_TO_TEXT',
                payload: {
                    id: message.id,
                    status: 'pending',
                    text: ''
                }
            })
        } else {
            this.props.dispatch({
                type: 'ML_ADD_TO_TEXT',
                payload: {
                    id: message.id,
                    status: 'pending',
                    text: '',
                    via: ''
                }
            })
        }
        // https://m.lizhiweike.com/open_api/recognize
        // http://118.89.45.243:9301/open_api/recognize
        axios.get(toTextApi, {
            params: {
                url: message.content.replace('audio.lizhiweike.com', 'audio.weike.fm')
            },
            timeout: 120000
        })
            .then(res => {
                this.props.dispatch({
                    type: 'ML_SET_TO_TEXT',
                    payload: {
                        id: message.id,
                        status: 'success',
                        text: res.data.translation,
                        via: res.data.message
                    }
                })
                // 原语音内的unread state是私有state，为了性能不流动state，用dom去掉unread
                const unreadEl = document.querySelector(`#message_${message.id} .voice-unread`)
                if (unreadEl) unreadEl.style.opacity = 0
                this.cacheMessageRead(message)
                this.toTextSuccessLog(message)
            })
            .catch(err => {
                console.log(err)
                this.props.dispatch({
                    type: 'ML_SET_TO_TEXT',
                    payload: {
                        id: message.id,
                        status: 'fail',
                        text: '',
                        via: ''
                    }
                })
            })
    }

    toTextSuccessLog(message) {
        this.props.dispatch({
            type: 'STATS_LOG',
            payload: {
                action: 'listen_audio',
                ts: new Date().getTime(),
                lecture_id: this.props.lecture.id,
                account_id: this.props.account.id,
                message_id: message.id
            }
        })
    }

    cacheMessageRead(message) {
        if (typeof message.id === 'number' && !this.isMessageRead(message.id)) {
            this.currentReads.push(message.id)
            localStorage.setItem('lectureReads/' + this.props.lecture.id, JSON.stringify(this.currentReads))
        }
    }

    handleOperate(message) {
        const menus = []
        const {role} = this.props
        let isCanToText = true
        if (!/^http/.test(message.content) || (message.status !== 'received' && message.status !== 'success' && message.status)) {
            isCanToText = false
        }
        if (message.status === 'failed' && (role.is_manager || role.is_lecturer)) {
            menus.push({
                label: '重发',
                onClick: () => {
                    this.handleResendMessage(message)
                }
            })
        }
        // 回滚2
        if (message.type === 'voice' && isCanToText) {
            menus.push({
                label: '转文字',
                onClick: () => {
                    this.handleVoiceToText(message)
                }
            })
        }

        if (role.is_manager || role.is_lecturer) {
            menus.push({
                label: '撤回',
                className: 'danger',
                onClick: () => {
                    this.handleDeleteMessageConfirm(message)
                }
            })
        } else if (message.type === 'file' || message.type === 'doc') {
            // 添加举报按钮
            menus.push({
                label: '请选择举报类型',
                className: 'danger',
                onClick: () => undefined
            }, {
                label: '色情、淫秽、低俗内容',
                onClick: () => this.reportFile('pornography', message)
            }, {
                label: '政治敏感信息',
                onClick: () => this.reportFile('political', message)
            }, {
                label: '不友善、违规',
                onClick: () => this.reportFile('violation', message)
            }, {
                label: '涉嫌谣言、欺诈',
                onClick: () => this.reportFile('fraud', message)
            }, {
                label: '其他',
                onClick: () => this.reportFile('others', message)
            })
        }

        this.context.page.showMenu(menus)
    }

    handleReward(account) {
        if (!account)
            return
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_REWARD',
            payload: {
                account: account
            }
        })
    }

    canOperate(message) {
        // 回滚1
        if (message.type === 'voice' || message.type === 'file' || message.type === 'doc') {
            return true
        }
        const {role} = this.props
        if (role.is_manager)
            return true
        if (role.is_lecturer)
            return true
        return false
    }

    componentWillUpdate(nextProps, nextState) {
        const {messageList} = nextProps
        // 结束课程的点击播放
        if (messageList.autoPlay) {
            this.props.dispatch({type: 'ML_UNSET_AUTOPLAY'})
            if (this.audioItems[messageList.autoPlayId]) {
                this.audioItems[messageList.autoPlayId].onVoiceBoxClick(null)
            }
        }
    }


    componentDidUpdate() {
        if (window.fixScrollTop) {
            const page = document.getElementById('page')
            const h = page.scrollHeight
            console.log(h, window.fixScrollTop.scrollHeight)
            if (h !== window.fixScrollTop.scrollHeight) {
                page.scrollTop -= window.fixScrollTop.scrollHeight - h
            }
            window.fixScrollTop = null
        }

        const {audioPlayer, messageList} = this.props

        if (messageList.currentAudioItem) {
            if (audioPlayer.audioState === 'playing') {
                // 语音条暂停时拖动不更新状态，只更新当前时间
                let {isLineDrag, audioState} = messageList.currentAudioItem.state
                if (isLineDrag && audioState === 'stopped') {
                    messageList.currentAudioItem.setState({
                        currentTime: audioPlayer.currentTime
                    })
                } else {
                    messageList.currentAudioItem.setState({
                        audioState: 'playing',
                        currentTime: audioPlayer.currentTime
                    })
                }
            } else if (audioPlayer.audioState === 'stopped') {
                messageList.currentAudioItem.setState({
                    audioState: 'stopped'
                })

                if (audioPlayer.autoPlayNext) {
                    const {messages} = this.props.messageList
                    const currentId = messageList.currentAudioItem.props.message.id
                    const currentMessage = messages.filter(m => m.id === currentId)[0]
                    if (currentMessage) {
                        /* 会出现 currentMessage 为 undefined 的情况，原因未明，可能跟撤回行为有关 */
                        const nextMessages = messages.filter(m => m.type === 'voice' && m.timestamp > currentMessage.timestamp)
                        if (nextMessages.length > 0) {
                            const item = this.audioItems[nextMessages[0].id]
                            if (item) {
                                item.onVoiceBoxClick(null)
                            }
                        }
                    }
                }
            }
        }


        const {messages} = this.props.messageList
        const {lecture} = this.props

        messages.map((m, i) => {
            if (m.status === 'saving') {
                const el = document.getElementById('message_' + m.id)
                if (el) {
                    this.context.classroomPage.scrollTo(el.offsetTop, true)
                }
            }

            if (m.status === 'send') {
                this.context.classroomPage.scrollToBottom(true)

                this.props.dispatch({
                    type: 'ML_TOGGLE_MESSAGE',
                    payload: {
                        id: m.id,
                        status: 'sending'
                    }
                })
                if (m.meta && m.meta.reply) {
                    m.reply = m.meta.reply
                }

                let form = new FormData()
                for (let key in m) {
                    if (key === 'content' && m.from === 'pc') {
                        continue
                    }
                    form.append(key, m[key])
                }

                form.append('ts', m.timestamp)

                // 如果有源页面的话，发送事件
                if(sessionStorage.getItem('event_source_page')) {
                  setEvent('cr_sd_msg_evt', { lecture_id: lecture.id })
                  sessionStorage.removeItem('event_source_page');
                }

                axios.post('/api/classroom/' + lecture.id + '/message/send', form, {
                    headers: {'content-type': 'multipart/form-data'}
                }).then((response) => {
                    if (response.data.code === 0) {
                        
                        this.props.dispatch({
                            type: 'ML_TOGGLE_MESSAGE',
                            payload: {
                                id: m.id,
                                status: 'success',
                                message: response.data.data.message
                            }
                        })
                    } else {
                        this.context.page.showAlert(response.data.msg)
                        this.props.dispatch({
                            type: 'ML_TOGGLE_MESSAGE',
                            payload: {
                                id: m.id,
                                status: 'failed'
                            }
                        })
                    }
                }).catch((error) => {
                    this.props.dispatch({
                        type: 'ML_TOGGLE_MESSAGE',
                        payload: {
                            id: m.id,
                            status: 'failed'
                        }
                    })
                })

            }

            if (m.status === 'scroll') {
                this.props.dispatch({
                    type: 'ML_TOGGLE_MESSAGE',
                    payload: {
                        id: m.id,
                        status: 'received'
                    }
                })
                const page = document.getElementById('page')
                if (page.scrollTop > page.scrollHeight - page.clientHeight - 300)
                    this.context.classroomPage.scrollToBottom(false)
            }
            return null
        })

        if (!this.keepPosition && this.props.messageList.initialized) {
            this.checkAutoPlay()
            this.context.classroomPage.checkLazyLoads()
        }
        this.dumpMessages()
    }

    checkAutoPlay() {
        const {role, lecture, showCloseUpDialog, liveroom} = this.props
        const messageId = localStorage.getItem('lastReadMessageId/' + lecture.id)
        /* 如果是点播，只会滚动到消息位置，不会自动播放，也不会弹出窗口 */
        const isLive = lecture.lecture_mode === 'default'
        if (this.props.messageList.messages.length >= 3) {
            let fake_close = (~~this.props.messageList.messages[this.props.messageList.messages.length - 1].timestamp) * 1000 > (Date.now() - 600000)
            let has_audio = this.props.messageList.messages.find(item => item.type === 'voice')
            if (!messageId && fake_close) {
                const el = document.getElementById('message_' + this.props.messageList.messages[this.props.messageList.messages.length - 1].id)
                if (el) {
                    this.context.classroomPage.scrollTo(el.offsetTop, true)
                }
                // localStorage.setItem('lastMessageId/' + lecture.id, this.props.messageList.messages[this.props.messageList.messages.length - 1].id)
            }

            if (has_audio) {
                this.props.dispatch({type: 'CLASSROOM_HAS_AUDIO_FOR_DIALOG'})
            }

            if (fake_close) {
                this.props.dispatch({type: 'CLASSROOM_FAKE_CLOSE_FOR_DIALOG'})
            }
        }


        if (lecture.status !== 'closed') {
            this.keepPosition = 'bottom'
            this.context.classroomPage.scrollToBottom(true)
            if (isLive) {
                const tsNow = parseInt(Date.now() / 1000, 10)
                if (lecture.start_timestamp <= tsNow && !showCloseUpDialog) {
                    this.playLastAudioItem()
                }
            }
        } else {
            if (messageId) {
                this.keepPosition = 'last'
                this.scrollToMessage(messageId, true)
                if (isLive) {
                    if (localStorage.getItem('autoPlay/' + lecture.id)) {
                        const item = this.audioItems[messageId]
                        if (item && !showCloseUpDialog && !role.is_manager && !role.is_lecturer) {
                            item.onVoiceBoxClick(null)
                            this.context.page.showToast('继续上次播放')
                        }
                    } else {
                        if (!role.is_manager && !role.is_lecturer) {
                            this.props.dispatch({type: 'CLASSROOM_SHOW_CLOSEUP_DIALOG'})
                        }
                    }
                }
            } else {
                // 课程已结束
                this.keepPosition = 'first'
                if (isLive) {
                    if (!role.is_manager && !role.is_lecturer) {
                        this.props.dispatch({type: 'CLASSROOM_SHOW_CLOSEUP_DIALOG'})
                    }
                }
            }
        }
    }

    playLastAudioItem() {
        if (this.audioItems.length < 1)
            return
        let keys = []
        for (let k in this.audioItems) {
            if (this.audioItems.hasOwnProperty(k))
                keys.push(k)
        }
        keys.sort()
        const messageId = keys[keys.length - 1]
        if (this.audioItems[messageId]) {
            this.audioItems[messageId].onVoiceBoxClick(null)
        }
    }

    render() {
        const {messages, initialized} = this.props.messageList
        const {lecture, can_reward, role} = this.props
        if (!initialized) {
            return <Preload/>
        }
        // 讲师自己或者未结束的课程，显示消息时间
        const showTimestamp = role.is_lecturer || lecture.status !== 'closed'
        let lastPrintTimestamp = 0
        return (
            <div>
                <ScrollButton/>
                <div className='message-list' ref="messageListContainer">
                    {messages.map((m, i) => {
                        let d = []
                        if (showTimestamp && m.timestamp && m.timestamp - lastPrintTimestamp > 600 && m.type !== 'reward') {
                            d.push(<TimeSpan timestamp={m.timestamp}/>)
                            lastPrintTimestamp = m.timestamp
                        }
                        d.push(<MessageItem
                            message={m}
                            key={m.id}
                            dispatch={this.props.dispatch}
                            canOperate={this.canOperate(m)}
                            handleOperate={this.handleOperate}
                            handleReward={this.handleReward}
                            lecturer={this.getLecturer(m)}
                            lecture={lecture}
                            can_reward={can_reward}
                            role={role}
                            messageList={this.props.messageList}
                        />)
                        return d
                    })}
                </div>
                {this.state.reportFileContent
                    ? <ClassroomReportFileDialog
                        onBack={() => this.state.reportFileContent.onBack()}
                        onReport={(reason) => this.state.reportFileContent.onReport(reason)}
                    /> : null}
                {this.state.reportSuccessToast
                    ? <Toast icon={'success-no-circle'} show={true}>举报成功</Toast>
                    : null}
            </div>
        )
    }
}

ClassroomMessageList.childContextTypes = {
    messageList: React.PropTypes.object
}

ClassroomMessageList.contextTypes = {
    classroomPage: React.PropTypes.object,
    page: React.PropTypes.object
}

export default connect((state) => ({
    audioPlayer: state.audioPlayer,
    messageList: state.messageList,
    liveroom: state.classroom.liveroom,
    role: state.classroom.role,
    lecture: state.classroom.lecture,
    lecturers: state.classroom.lecturers,
    showScrollButton: state.classroom.showScrollButton,
    can_reward: state.classroom.options.can_reward,
    showDiscussListArea: state.classroom.showDiscussListArea,
    showCloseUpDialog: state.classroom.showCloseUpDialog,
    evaluationAudioCount: state.wk.wkEvaluation.evaluationAudioCount,
    account: state.account
}))(ClassroomMessageList)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomMessageList.js